module.exports = __webpack_public_path__ + "img/127ne.019bde71.svg";